import {
    PURCHASE_LIST,
    PURCHASE_PAGINATION
} from './constant';

export const initStateFeed = {
    purchaseList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case PURCHASE_LIST: {
            return {
                ...state,
                purchaseList: action.payload,
            };
        }
        case PURCHASE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
